<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>I want to snooze the alert:</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="radio">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="snooze"
                id="7-days"
                :value="1"
                v-model="snoozeType"
              />
              <label class="form-check-label" for="7-days">
                For 7 days
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="snooze"
                id="30-days"
                :value="2"
                v-model="snoozeType"
              />
              <label class="form-check-label" for="30-days">
                For 30 days
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="snooze"
                id="pick-date"
                :value="3"
                v-model="snoozeType"
              />
              <label class="form-check-label" for="pick-date">
                For the period:
              </label>
            </div>
          </div>
          <div class="pick-date-input" :class="{ disabled: snoozeType !== 3 }">
            <div class="form-group row">
              <label for="from" class="col-2 col-form-label">From</label>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  id="from"
                  :disabled="snoozeType !== 3"
                  v-model="date.from"
                />
                <date-picker
                  v-model="date.from"
                  type="date"
                  format="DD/MM/YYYY"
                  value-type="format"
                  :disabled-date="disabledBeforeToday"
                  :disabled="snoozeType !== 3"
                  :clearable="false"
                  placeholder="Select date"
                ></date-picker>
              </div>
            </div>
            <div class="form-group row">
              <label for="to" class="col-2 col-form-label">To</label>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  id="to"
                  placeholder="DD/MM/YYYY"
                  :disabled="snoozeType !== 3"
                  v-model="date.to"
                />
                <date-picker
                  v-model="date.to"
                  type="date"
                  format="DD/MM/YYYY"
                  value-type="format"
                  :disabled-date="disabledBeforeTomorrow"
                  :disabled="snoozeType !== 3"
                  :clearable="false"
                  placeholder="DD/MM/YYYY"
                ></date-picker>
              </div>
            </div>
            <div v-if="warning" class="warning text-danger">{{ warning }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="closeModal"
          >
            Cancel
          </button>

          <button type="button" class="btn btn-primary" @click="submit">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import * as vClickOutside from 'v-click-outside';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import {
  checkIsValidDate,
  transformDateFormatFromDDMMYYYYToYYYYMMDD,
  formatDatePickerInput
} from '../../../utils/common';

export default {
  name: 'SnoozeAlertRSModal',
  components: { DatePicker },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      snoozeType: 1,
      date: {
        from: dayjs().format('DD/MM/YYYY'),
        to: ''
      },
      warning: ''
    };
  },
  watch: {
    'date.to': function(val, preVal) {
      this.warning = '';

      if (val.length > preVal.length)
        this.date.to = formatDatePickerInput(this.date.to);
    },

    'date.from': function(val, preVal) {
      this.warning = '';

      if (val.length > preVal.length)
        this.date.from = formatDatePickerInput(this.date.from);
    }
  },
  methods: {
    disabledBeforeToday(date) {
      const isDateBeforeToday = dayjs(date).isBefore(
        dayjs().subtract(1, 'day')
      );
      return isDateBeforeToday;
    },

    disabledBeforeTomorrow(date) {
      const isDateBeforeTomorrow = dayjs(date).isBefore(dayjs());
      return isDateBeforeTomorrow;
    },

    submit() {
      if (this.snoozeType === 3) {
        const isDateFromValid = checkIsValidDate(this.date.from);
        const isDateToValid = checkIsValidDate(this.date.to);

        if (!isDateFromValid || !isDateToValid) {
          this.warning = 'Please enter a valid date: DD/MM/YYYY.';
        } else {
          const from = transformDateFormatFromDDMMYYYYToYYYYMMDD(
            this.date.from
          );
          const to = transformDateFormatFromDDMMYYYYToYYYYMMDD(this.date.to);

          const isDateFromBeforeDateTo = dayjs(from).isBefore(dayjs(to));

          const isDateFromAfterYesterday = dayjs(from).isAfter(
            dayjs().subtract(1, 'day')
          );

          if (!isDateFromBeforeDateTo) {
            this.warning = 'Start date must be earlier than end date.';
          } else if (!isDateFromAfterYesterday) {
            this.warning = 'Start date must not be earlier than today.';
          } else {
            const val = {
              snoozeFrom: dayjs(from).toISOString(),
              snoozeTo: dayjs(to).toISOString()
            };

            this.$emit('onSetSnooze', val);
          }
        }
      } else {
        const val = {
          snoozeFrom: dayjs().toISOString(),
          snoozeTo:
            this.snoozeType === 1
              ? dayjs()
                  .add(7, 'day')
                  .toISOString()
              : dayjs()
                  .add(30, 'day')
                  .toISOString()
        };

        this.$emit('onSetSnooze', val);
      }
    },

    closeModal() {
      this.$emit('onCloseModal');
    }
  },
  mounted() {
    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        this.closeModal();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: initial;
  width: 22rem;
}

.modal-header {
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;

  h5 {
    margin: 0;
    font-size: 1rem;
  }
}

.modal-body {
  margin: 0 1rem;

  .radio {
    margin: 0;

    .form-check {
      margin-bottom: 1rem;
    }
  }

  .pick-date-input {
    position: relative;
    margin: 1rem;

    input {
      display: inline-block;
      width: 10rem;

      &::placeholder {
        color: $text-grey;
      }
    }

    .warning {
      position: absolute;
      top: 6rem;
      font-size: 0.8rem;
      white-space: nowrap;
    }

    &.disabled {
      label {
        color: #ccc;
      }
    }
  }
}

.modal-footer {
  justify-content: space-evenly;
}

// Set up date picker style
.pick-date-input {
  ::v-deep .mx-datepicker {
    width: 0rem;
    margin-left: 2rem;
    padding: 0;
    cursor: pointer;

    &.disabled {
      cursor: default;
    }

    input.mx-input {
      visibility: hidden;
      border: none;
      box-shadow: none;
      width: 0;
    }

    .mx-input:disabled,
    .mx-input.disabled {
      background-color: initial;
    }
  }
}
</style>
